import type { IconSvgObject } from './types';

const Hospital01Icon: IconSvgObject = [
  ["path", { d: "M14 2V4.49829M14 4.49829V7M14 4.49829H10M10 2V4.49829M10 4.49829V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 5H6C4.89543 5 4 5.89543 4 7V22M17 5H18C19.1046 5 20 5.89543 20 7V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 11H16H14Z", fill: "currentColor", key: "2" }],
  ["path", { d: "M14 14H16H14Z", fill: "currentColor", key: "3" }],
  ["path", { d: "M8 14H10H8Z", fill: "currentColor", key: "4" }],
  ["path", { d: "M8 11H10H8Z", fill: "currentColor", key: "5" }],
  ["path", { d: "M14 11H16M14 14H16M8 14H10M8 11H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "6" }],
  ["path", { d: "M2.5 22H9.5V19C9.5 18.4477 9.94772 18 10.5 18H13.5C14.0523 18 14.5 18.4477 14.5 19V22H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "7" }]
];

export default Hospital01Icon;
